import { IconContent } from '@icons';

export const arrowInRectangle: IconContent = {
    sm: '<path d="M2.5 2H2v3h1V3h10v10H3v-2H2v3h12V2H2.5Zm4.146 8.146L8.293 8.5H2v-1h6.293L6.646 5.854l.708-.708 2.5 2.5.353.354-.353.354-2.5 2.5-.708-.708Z" />',
};
